export default "__VITE_ASSET__JLAynKzm__"